export default __webpack_public_path__ + "static/media/monaco.a9fe814a.jpg";